import { render, staticRenderFns } from "./ownerDetailMember.vue?vue&type=template&id=4c006340&scoped=true"
import script from "./ownerDetailMember.vue?vue&type=script&lang=js"
export * from "./ownerDetailMember.vue?vue&type=script&lang=js"
import style0 from "./ownerDetailMember.vue?vue&type=style&index=0&id=4c006340&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c006340",
  null
  
)

export default component.exports